<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="modal fade" id="modal_form_novedad_export">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-geogo pt-2 pb-2">
            <h4 class="modal-title text-white">Generar Informe Novedades</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <!-- Filtros -->
              <div class="col-md-6">
                <div class="card m-0">
                  <div class="card-header bg-lightblue">
                    <h5 class="m-0">Filtros</h5>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="form-group col-md-4">
                        <label>Fecha Inicial</label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha_inicial"
                          :class="
                            $v.filtros.fecha_inicial.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Fecha Final</label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha_final"
                          :class="
                            $v.filtros.fecha_final.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                        />
                      </div>
                      <div class="form-group col-md-8">
                        <label>Empresa</label>
                        <v-select
                          v-model="empresa"
                          label="razon_social"
                          class="form-control form-control-sm p-0"
                          :class="[
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          :options="listasForms.empresas"
                          @search="buscarEmpresas"
                          @input="selectEmpresa()"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label>Viaje</label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.viaje_id"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Vehículo</label>
                        <v-select
                          v-model="vehiculo"
                          label="placa"
                          class="form-control form-control-sm p-0"
                          :class="[
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          :options="listasForms.vehiculos"
                          @search="buscarVehiculos"
                          @input="selectVehiculo()"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label>Remolque</label>
                        <v-select
                          v-model="remolque"
                          label="placa"
                          class="form-control form-control-sm p-0"
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          :options="listasForms.remolques"
                          @search="buscarRemolques"
                          @input="selectRemolque()"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-12">
                        <label>Conductor</label>
                        <v-select
                          v-model="conductor"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          :options="listasForms.conductores"
                          @search="buscarConductores"
                          @input="selectConductor()"
                        ></v-select>
                      </div>
                      <div class="col-md-6">
                        <label>Sitio Origen</label>
                        <v-select
                          v-model="sitio_origen"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          :options="listasForms.sitios"
                          @search="buscarSitios"
                          @input="selectSitioOrigen()"
                        ></v-select>
                      </div>
                      <div class="col-md-6">
                        <label>Sitio Destino</label>
                        <v-select
                          v-model="sitio_destino"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          :options="listasForms.sitios"
                          @search="buscarSitios"
                          @input="selectSitioDestino()"
                        ></v-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Campos Visibles -->
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header bg-lightblue">
                        <h5 class="m-0">Campos</h5>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_fecha_novedad"
                              v-model="form.fecha_novedad"
                              class="custom-control-input"
                              readonly
                            />
                            <label
                              class="custom-control-label"
                              for="fp_fecha_novedad"
                              >Fecha Novedad</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_tipo_novedad"
                              v-model="form.tipo_novedad"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_tipo_novedad"
                              >Tipo Novedad</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_sub_novedad"
                              v-model="form.sub_novedad"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_sub_novedad"
                              >Sub Novedad</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_latitud"
                              v-model="form.latitud"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="fp_latitud"
                              >Latitud</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_longitud"
                              v-model="form.longitud"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_longitud"
                              >Longitud</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_direccion"
                              v-model="form.direccion"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_direccion"
                              >Dirección</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_velocidad"
                              v-model="form.velocidad"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_velocidad"
                              >Velocidad</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_viaje"
                              v-model="form.viaje"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="fp_viaje"
                              >Viaje</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_n_guia"
                              v-model="form.n_guia"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="fp_n_guia"
                              ># Guía</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_n_ticket"
                              v-model="form.n_ticket"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_n_ticket"
                              ># Ticket</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_Vehículo"
                              v-model="form.vehiculo"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_Vehículo"
                              >Vehículo</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_Conductor"
                              v-model="form.conductor"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_Conductor"
                              >Conductor</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_sitio_origen"
                              v-model="form.sitio_origen"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_sitio_origen"
                              >Sitio Origen</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_sitio_destino"
                              v-model="form.sitio_destino"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fp_sitio_destino"
                              >Sitio Destino</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox col-md-6">
                            <input
                              type="checkbox"
                              id="fp_Empresa"
                              v-model="form.empresa"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="fp_Empresa"
                              >Empresa</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" v-if="!$v.filtros.$invalid">
                    <div class="card m-0">
                      <div class="card-header bg-light">
                        <div class="row justify-content-between">
                          <div class="col-md-12">
                            <div class="btn-group float-right">
                              <button
                                @click="generarListadoExcel('mail')"
                                type="button"
                                class="btn btn-sm btn-info"
                                v-if="!$v.form_correo.$invalid"
                              >
                                <i class="far fa-envelope"></i>
                              </button>
                              <button
                                @click="generarListadoExcel('excel')"
                                type="button"
                                class="btn btn-sm btn-success"
                                v-if="!$v.filtros.$invalid"
                              >
                                <i class="far fa-file-excel"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-body">
                        <label for="correo">Correos</label>
                        <textarea
                          id="observaciones"
                          name=""
                          rows="3"
                          class="form-control form-control-sm"
                          placeholder="Correos electrónicos"
                          v-model="form_correo.correos"
                          :class="[
                            $v.form_correo.correos.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                        ></textarea>
                        <div class="info-box bg-gradient-warning mt-3 mb-0">
                          <span class="info-box-icon">
                            <i class="fas fa-exclamation-triangle"></i>
                          </span>
                          <div class="info-box-content">
                            <p>
                              Por favor ingresar los correos seguidos de una
                              coma ejemplo:
                              <strong>prueba@gmail.com,</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";

export default {
  name: "InformeFlotaPropiaExport",
  components: { Loading, vSelect },

  data() {
    return {
      cargando: false,
      vehiculo: {},
      remolque: {},
      conductor: {},
      sitio_origen: {},
      sitio_destino: {},
      empresa: {},
      seguimiento: null,
      listasForms: {
        empresas: [],
        sitios: [],
        vehiculos: [],
        remolques: [],
        conductores: [],
      },
      filtros: {
        fecha_inicial: null,
        fecha_final: null,
        n_guia: null,
        n_ticket: null,
        viaje_id: null,
        vehiculo_id: null,
        remolque_id: null,
        conductor_id: null,
        sitio_origen_id: null,
        sitio_destino_id: null,
        empresa_id: null,
      },
      form: {
        fecha_novedad: true,
        tipo_novedad: true,
        sub_novedad: true,
        latitud: true,
        longitud: true,
        direccion: true,
        velocidad: true,
        n_guia: true,
        n_ticket: true,
        viaje: true,
        vehiculo: true,
        conductor: true,
        sitio_origen: true,
        sitio_destino: true,
        empresa: true,
      },
      form_correo: {
        correos: null,
      },
    };
  },

  validations: {
    filtros: {
      fecha_inicial: {
        required,
      },
      fecha_final: {
        required,
      },
    },
    form_correo: {
      correos: {
        required,
        containsComma: (value) => {
          return !value || value.indexOf(",") !== -1;
        },
      },
    },
  },

  methods: {
    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/empresas/lista?razon=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: 2,
            },
          })
          .then(function(response) {
            me.listasForms.empresas = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarRemolques(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/remolques/lista?placa=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: 2,
            },
          })
          .then(function(response) {
            me.listasForms.remolques = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarVehiculos(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/vehiculos/lista?placa=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: 2,
            },
          })
          .then(function(response) {
            me.listasForms.vehiculos = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarConductores(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/conductores/lista?nombres=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: 2,
            },
          })
          .then(function(response) {
            me.listasForms.conductores = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarSitios(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/sitios/lista?nombres=" + search;
        axios
          .get(url)
          .then(function(response) {
            me.listasForms.sitios = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    selectEmpresa() {
      this.filtros.empresa_id = null;
      if (this.empresa) {
        this.filtros.empresa_id = this.empresa.id;
      }
    },

    selectVehiculo() {
      this.filtros.vehiculo_id = null;
      if (this.vehiculo) {
        this.filtros.vehiculo_id = this.vehiculo.id;
      }
    },

    selectRemolque() {
      this.filtros.remolque_id = null;
      if (this.remolque) {
        this.filtros.remolque_id = this.remolque.id;
      }
    },

    selectConductor() {
      this.filtros.conductor_id = null;
      if (this.conductor) {
        this.filtros.conductor_id = this.conductor.id;
      }
    },

    selectSitioOrigen() {
      this.filtros.sitio_origen_id = null;
      if (this.sitio_origen) {
        this.filtros.sitio_destino_id = this.sitio_origen.id;
      }
    },

    selectSitioDestino() {
      this.filtros.sitio_destino_id = null;
      if (this.sitio_destino) {
        this.filtros.destinoid = this.sitio_destino.id;
      }
    },

    generarListadoExcel(accion = null) {
      this.cargando = true;
      this.filtros.correos = this.form_correo.correos;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/novedadesHidro/exportNovedades",
        data: {
          form: this.form,
          filtros: this.filtros,
          accion,
        },
      })
        .then((response) => {
          this.cargando = false;
          const data = response.data;
          if (!data.error) {
            if (accion == "excel") {
              location.href = data.url;
            }
            this.$swal({
              customClass: {
                container: "my-swal",
              },
              icon: "success",
              title: data.message,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
          } else {
            this.$swal({
              icon: "error",
              title: data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    limpiarFormulario() {
      this.listasForms = {
        empresas: [],
        vehiculos: [],
        remolques: [],
        conductores: [],
        sitios: [],
      };
      this.vehiculo = {};
      this.remolque = {};
      this.conductor = {};
      this.sitio_origen = {};
      this.sitio_destino = {};
      this.empresa = {};

      this.filtros = {
        fecha_inicial: null,
        fecha_final: null,
        n_guia: null,
        viaje_id: null,
        vehiculo_id: null,
        remolque_id: null,
        conductor_id: null,
        sitio_origen_id: null,
        sitio_destino_id: null,
        empresa_id: null,
      };

      this.form_correo = {
        correos: null,
      };
    },
  },

  beforeMount() {
    this.filtros.empresa_id = this.$store.getters.getUser.empresa
      ? this.$store.getters.getUser.empresa.id
      : null;
    this.empresa = this.$store.getters.getUser.empresa
      ? {
          id: this.$store.getters.getUser.empresa.id,
          razon_social: this.$store.getters.getUser.empresa.razon_social,
        }
      : null;
  },
};
</script>

<style>
.my-swal {
  z-index: 20000 !important;
}
</style>
